<template>
  <div>
    <el-table border :data="data.list" :row-key="rowKey" @selection-change="selectionChange">
      <slot/>
    </el-table>
    <div class="pager" v-if="data.page && data.pageSize && data.totalCount !== null && data.totalCount !== undefined">
      <el-pagination background @current-change="changePage" :total="data.totalCount"
                     v-model="data.page" :page-size="data.pageSize"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableUnionPager",
  props: {
    data: {
      type: Object,
      default: {
        list: [],
        totalCount: 0,
        page: 1,
        pageSize: 10
      }
    },
    rowKey: {
      type: String | Function,
      default: null
    }
  },
  methods: {
    changePage(page) {
      this.$emit('current-change', page);
    },
    selectionChange(rows) {
      this.$emit('selection-change', rows);
    }
  }
}
</script>

<style scoped>
.pager {
  background-color: #ffffff;
  margin-top: 6px;
  box-sizing: border-box;
  border-style: solid;
  border-width: 1px;
  border-color: #eeeeee;
  padding: 6px 8px;
  text-align: right;
}
</style>